import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import { getStatusLabel } from "../constants/actions";

/**
 * The status control while an undo request is pending: the same pill the
 * dropdown draws, with a warning mark, and nothing to open but the request.
 *
 * It replaces the dropdown rather than disabling it. The server refuses every
 * status change in this state, so a menu of moves would be a menu of errors, and
 * the request is the one thing worth opening. The marker is for everyone who can
 * see the candidate: the approver reaches Approve and Reject through it, the
 * requester reaches Cancel, and anyone else reads why the status is stuck.
 */
const PendingUndoChip = ({ currentStatus, onOpen, className }) => {
  const label = getStatusLabel(currentStatus);

  return (
    <Button
      type="button"
      onClick={onOpen}
      aria-label={`${label}, undo request awaiting approval. Open it.`}
      className={cn(
        "flex items-center gap-1.5 rounded-full bg-button-secondary px-4 py-2 text-sm font-medium text-text-base",
        "cursor-pointer select-none focus:outline-none",
        className,
      )}
    >
      <span>{label}</span>
      <AlertTriangle size={14} className="shrink-0 text-warning" aria-hidden="true" />
    </Button>
  );
};

export default PendingUndoChip;
